import { O11Y_BLOCK_LIST_ORG_IDS } from '#pplx/frontend/common/o11y/o11yBlockList.js';
/** Drops instrumentation events for organizations excluded from telemetry. */
export const blocklistedOrgMiddleware = (event, { analyticsUser }) => analyticsUser.orgId !== undefined && O11Y_BLOCK_LIST_ORG_IDS.includes(analyticsUser.orgId)
    ? { state: 'stop' }
    : { state: 'continue', event };
//# sourceMappingURL=blocklistedOrgMiddleware.js.map